
export default function Products() {
  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <div className="inline-block mb-4">
            <span className="text-cyan-500 text-xs uppercase tracking-widest font-medium">
              Our Products
            </span>
          </div>
          
          <h2 className="text-6xl font-bold mb-6">
            <span className="text-slate-900">VPN</span>
            <span className="text-slate-400"> & </span>
            <span className="text-cyan-500">Cleaner</span>
          </h2>
          
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Two powerful applications designed to protect and optimize your iOS devices
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-7">
            <div className="relative h-full min-h-[600px] bg-gradient-to-br from-slate-900 via-slate-800 to-cyan-900 rounded-3xl overflow-hidden p-12 flex flex-col justify-between">
              <div className="absolute inset-0 opacity-20">
                <img 
                  src="https://public.readdy.ai/ai/img_res/42a1c522c8737bf5e5bfeae08b9faba6.jpg"
                  alt="VPN Background"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="relative z-10">
                <div className="inline-flex items-center gap-2 bg-cyan-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                  <i className="ri-shield-keyhole-line text-cyan-400"></i>
                  <span className="text-cyan-400 text-sm font-medium">Security & Privacy</span>
                </div>
                
                <h3 className="text-5xl font-bold text-white mb-6">
                  VPN Application
                </h3>
                
                <ul className="space-y-4">
                  {[
                    'Military-grade encryption for your data',
                    'Global server network for optimal speed',
                    'No-logs policy ensuring complete privacy',
                    'One-tap connection for instant protection',
                    'Automatic kill switch for security'
                  ].map((feature, index) => (
                    <li key={index} className="flex items-start gap-3 text-slate-200">
                      <i className="ri-checkbox-circle-fill text-cyan-400 text-xl mt-1"></i>
                      <span className="text-lg">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="relative z-10 flex justify-center mt-8">
                <img 
                  src="https://readdy.ai/api/search-image?query=iPhone%20mockup%20showing%20VPN%20app%20interface%20with%20glowing%20cyan%20connected%20status%20indicator%2C%20modern%20minimalist%20UI%20design%20with%20connection%20button%20and%20server%20selection%2C%20professional%20product%20shot%20with%20subtle%20shadows%20on%20dark%20background&width=400&height=600&seq=vpn-phone-ui&orientation=portrait"
                  alt="VPN App Interface"
                  className="w-64 h-auto object-contain drop-shadow-2xl"
                />
              </div>
            </div>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-8">
            <div className="relative h-full min-h-[290px] bg-gradient-to-br from-slate-100 to-slate-200 rounded-3xl overflow-hidden p-10 flex flex-col justify-between">
              <div className="absolute top-0 right-0 w-48 h-48 bg-cyan-400/20 rounded-full blur-3xl"></div>
              
              <div className="relative z-10">
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-white shadow-lg mb-6">
                  <i className="ri-database-2-line text-3xl text-slate-700"></i>
                </div>
                
                <h3 className="text-3xl font-bold text-slate-900 mb-3">
                  Storage Optimization
                </h3>
                
                <p className="text-slate-600 leading-relaxed">
                  Intelligent analysis and cleanup of unnecessary files, freeing up valuable storage space on your device.
                </p>
              </div>

              <div className="relative z-10 mt-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=iOS%20storage%20optimization%20interface%20showing%20colorful%20storage%20breakdown%20chart%20with%20categories%2C%20clean%20modern%20UI%20design%20with%20progress%20bars%20and%20file%20type%20icons%2C%20light%20background%20with%20cyan%20and%20blue%20accents&width=600&height=400&seq=storage-ui&orientation=landscape"
                  alt="Storage Optimization"
                  className="w-full h-32 object-cover rounded-2xl"
                />
              </div>
            </div>

            <div className="relative h-full min-h-[290px] bg-gradient-to-br from-pink-500 via-purple-500 to-indigo-600 rounded-3xl overflow-hidden p-10 flex flex-col justify-between">
              <div className="relative z-10">
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-white/20 backdrop-blur-sm mb-6">
                  <i className="ri-speed-up-line text-3xl text-white"></i>
                </div>
                
                <h3 className="text-3xl font-bold text-white mb-3">
                  Performance Boost
                </h3>
                
                <p className="text-white/90 leading-relaxed">
                  Advanced cleaning algorithms that remove junk files, cache, and temporary data to keep your device running smoothly.
                </p>
              </div>

              <div className="relative z-10 mt-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20interface%20showing%20cleaning%20progress%20with%20circular%20progress%20indicator%20and%20speed%20boost%20animation%2C%20modern%20gradient%20UI%20with%20white%20elements%2C%20performance%20metrics%20and%20clean%20button&width=600&height=400&seq=cleaner-ui&orientation=landscape"
                  alt="Cleaner Interface"
                  className="w-full h-32 object-cover rounded-2xl"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
